import { getGeocode } from "use-places-autocomplete";

import { GoogleAddress } from "@shared/components/AddressPulldown/GoogleAddress/GoogleAddress";
import type { AddressInformationData } from "@shared/types/fields";
import type {
  BusinessAddressAttributes,
  StripePersonAttributes,
} from "@shared/types/graphqlGenerated";

import type { StatesData } from "./StatesInfo.query";

const placesAutocompleteBoilerplate = (
  addressInformationData:
    | AddressInformationData
    | BusinessAddressAttributes
    | StripePersonAttributes,
  handleSetAddressInformation: (
    addressInfo: AddressInformationData | BusinessAddressAttributes | StripePersonAttributes
  ) => void,
  data: StatesData
) => {
  const handleBlur = (onBlur, suggestions) => async e => {
    const streetAddress =
      "streetAddress" in addressInformationData && addressInformationData.streetAddress;
    const address1 = "address1" in addressInformationData && addressInformationData.address1;
    onBlur(e);

    const suggestionActive = suggestions.some(suggestion => suggestion.active);
    if (suggestionActive) {
      await onSuggestionSelect(streetAddress ?? address1);
    }
  };

  const onSuggestionSelect: any = async (
    address: string,
    placeId: string,
    includeLatLng?: boolean
  ) => {
    const placeDetails = await getGeocode({ placeId });
    const streetNumber = address.split(" ")[0];
    const states = data?.viewer.states;
    const phone = "phone" in addressInformationData ? addressInformationData.phone : "";

    handleSetAddressInformation({
      phone,
      ...GoogleAddress(placeDetails, streetNumber, states, includeLatLng),
    });
  };

  return { onSuggestionSelect, handleBlur };
};

export { placesAutocompleteBoilerplate };
